import { TimelineModel } from 'src/components/messages/timelineModel';

class PatientTimelineModel extends TimelineModel {
  id = 'PatientTimelineModel';

  _events = {
    profile: 'handleProfile',
    openPatient: 'onOpenPatient',
    'foxsocket:message:treatment': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  listParams(loadMore) {
    const req = super.listParams(loadMore);

    if (!req) return null;

    return {
      ...req,
      patientId: req.partnerId
    };
  }
  onOpenPatient = (patient = null) => {
    if (!patient?.id) return;

    this.onOpenContact({
      contact: {
        ...patient,
        partnerId: patient.id
      }
    });
  };
}
const timelineModel = new PatientTimelineModel();

export default timelineModel;
